import { cloneElement, type ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';
import ListItemText from '@mui/material/ListItemText';
import type { HtmlElementProps } from '@/types';
import BaseMenuItem from '../BaseMenuItem';
import { classes } from './utils';

export interface MenuItemProps extends HtmlElementProps<HTMLLIElement> {
  destructive?: boolean;
  label: string;
  icon?: ReactElement;
  endIcon?: ReactElement;
}

export default function MenuItem({
  destructive = false,
  className,
  label,
  icon,
  endIcon,
  ...props
}: MenuItemProps) {
  return (
    <BaseMenuItem
      className={twMerge(destructive && classes.destructive, className)}
      {...props}>
      {icon &&
        cloneElement(icon, {
          className: twMerge(
            classes.icon,
            destructive && classes.destructiveIcon,
            icon.props.className
          ),
        })}
      <ListItemText
        primaryTypographyProps={{ color: 'inherit', className: classes.label }}>
        {label}
      </ListItemText>
      {endIcon &&
        cloneElement(endIcon, {
          className: twMerge(classes.endIcon, endIcon.props.className),
        })}
    </BaseMenuItem>
  );
}
